import * as React from "react";
import { PublicPageContainer } from "../../ui/PublicPageContainer";
import { Card } from "react-bootstrap";
import { RavenOnCloudAnimation } from "@commonComponents/ui/RavenOnCloudAnimation";
import "./_page-not-found.scss";
import AppRoutes from "../../../AppRoutes";
import { useAuth } from "../../../hooks/useAuth";

const logo = require("img/logo.svg");

export function PageNotFound() {
    const { cloudAccount } = useAuth();

    return (
        <PublicPageContainer>
            <div className="my-auto page-not-found">
                <Card className="d-flex border-0 flex-row flex-wrap overflow-hidden rounded-4">
                    <div className="raven-on-cloud-animation overflow-hidden">
                        <RavenOnCloudAnimation />
                    </div>
                    <div className="panel-content p-5">
                        <div className="d-flex px-6 flex-column align-items-start justify-content-center gap-3">
                            <img src={logo} width="222" className="mb-2" alt="RavenDB Cloud Solutions" />
                            <div className="vstack gap-2">
                                <h1 className="m-0">We can’t find that page</h1>
                                <p>
                                    Maybe the link is broken, or the page doesn’t exist anymore. Let’s help you get
                                    where you need to go.
                                </p>
                            </div>
                            <div className="hstack gap-2">
                                <a href={AppRoutes.forHomePage().link()} className="btn btn-primary">
                                    Go back to homepage
                                </a>
                                <a
                                    href={
                                        cloudAccount
                                            ? AppRoutes.forSupport().link({ cloudAccount })
                                            : "https://cloud.ravendb.net/request-support"
                                    }
                                    className="btn btn-secondary"
                                >
                                    Contact support
                                </a>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </PublicPageContainer>
    );
}

export default PageNotFound;
